import React from 'react';
import PropTypes from 'prop-types';
import UsersText from 'App/components/UsersText';
import { avatar as Avatar } from 'App/babel/components/LegacyReactTemplates';

export default class Users extends React.Component {
	constructor(props) {
		super(props);

		var t = Tools.$translate;
		this.lang = {
			noAccountManager: t('default.noAccountManager')
		};
	}

	render() {
		if (this.props?.account?.merging) {
			return <td />;
		}

		const Component = !this.props.createNewAccountRow ? 'div' : 'td';

		return (
			<Component className={`DataSourceColumn ${!this.props.createNewAccountRow ? 'align-items-center' : ''}`}>
				<div
					className={
						!Array.isArray(this.props?.account?.users) || this.props?.account?.users?.length === 0
							? 'no-account-manager'
							: 'with-account-manager'
					}
				>
					<Avatar size={30} user={this.props?.account?.users?.[0]} />
					<UsersText users={this.props?.account?.users} placeholder={this.lang.noAccountManager}></UsersText>
				</div>
			</Component>
		);
	}
}

Users.propTypes = {
	account: PropTypes.object,
	createNewAccountRow: PropTypes.bool
};
